export default {
  checkboxWrapper: {
    marginTop: -5,
    marginBottom: 14
  }
}
